import script from "./empty-state.vue?vue&type=script&lang=ts&setup=true"
export * from "./empty-state.vue?vue&type=script&lang=ts&setup=true"

import "./empty-state.vue?vue&type=style&index=0&id=13075594&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13075594"]])

export default __exports__